// generated by parseCompaniesCsv.js
// DO NOT EDIT MANUALLY. ONLY GENERATE USING 'npm run parse-companies'
/**** GEN:S id="companies-csv" */
export const companies = JSON.parse(`[
  {
    "companyName": "Chandler Studios",
    "focuses": "3D printing, manufacturing and design",
    "positionTypes": [
      "Interns",
      "Full-time employees",
      "Part-time employees",
      "Contract workers",
      "Freelancers",
      "Volunteers"
    ],
    "website": "https://www.chandlerla.com/",
    "virtualTimes": "",
    "inPersonTimes": "",
    "logoUrlCheckString": "Option 2"
  },
  {
    "companyName": "Amerra, Inc.",
    "focuses": "Animation, Game Development, Graphic Design, Virtual Production, UI/UX, Interactive Media",
    "positionTypes": [
      "Interns",
      "Part-time employees",
      "Contract workers",
      "Freelancers",
      "Researchers"
    ],
    "website": "www.amerra.com",
    "virtualTimes": "",
    "inPersonTimes": "11:00 - 11:30, 11:30 - 12:00, 12:30 - 1:00",
    "logoUrlCheckString": "Option 2"
  },
  {
    "companyName": "Powerhouse Animation Studios",
    "focuses": "Animation",
    "positionTypes": [
      "Full-time employees"
    ],
    "website": "powerhouseanimation.com",
    "virtualTimes": "11:30 - 12:00, 12:30 - 1:00, 1:00 - 1:30, 1:30 - 2:00",
    "inPersonTimes": "",
    "logoUrlCheckString": "https://drive.google.com/file/d/1hvM19VVbAgA6MYdVl-4_ugk3OHGs0Vgq/view?usp=sharing"
  },
  {
    "companyName": "Texas Film Commission",
    "focuses": "State Government with resources to help students get jobs in Texas in the following sectors: animation, VFX, video games, XR",
    "positionTypes": [
      "Interns",
      "Members"
    ],
    "website": "https://gov.texas.gov/film",
    "virtualTimes": "",
    "inPersonTimes": "All Day",
    "logoUrlCheckString": "option 2"
  },
  {
    "companyName": "Red Productions",
    "focuses": "Commercial Production",
    "positionTypes": [
      "Interns",
      "Contract workers",
      "Freelancers",
      "Volunteers",
      "Members"
    ],
    "website": "redproductions.com",
    "virtualTimes": "",
    "inPersonTimes": "All Day",
    "logoUrlCheckString": "Option 2"
  },
  {
    "companyName": "AEM Creations",
    "focuses": "Animation, Graphic Design, Interactive Media",
    "positionTypes": [
      "Interns"
    ],
    "website": "www.aem2create.com",
    "virtualTimes": "",
    "inPersonTimes": "All Day",
    "logoUrlCheckString": "https://drive.google.com/file/d/1I_mrVU7Irorlj1JW-cOVlDjn4QNPgW_D/view?usp=sharing"
  }
]`);
/**** GEN:E id="companies-csv" */

// edit manually
export const pastCompanies: string[] = Array.from(new Set([
  "900lbs",
  "A Bunch Of Short Guys",
  "AEM Creations",
  "Aggieland Outfitters",
  "Bluepoint Games",
  "BonusXP",
  "Booz Allen Hamilton, Inc.",
  "C.C. Creations",
  "Cinevva",
  "Click Here Labs - TRG",
  "Cloud Imperium Games",
  "Credera",
  "Deloitte",
  "Digital Seat Media",
  "DreamWorks Animation",
  "Electronic Arts",
  "Framestore",
  "Game Worlds",
  "Gearbox Software",
  "IMG Studio",
  "Jacobs Architects",
  "Mighty Coconut",
  "Pixar",
  "Powerhouse Animation",
  "ReelFX",
  "Six Foot Games",
  "Texas Film Commission",
  "Texas Moving Picture Alliance (TXMPA)",
  "The Third Floor, Inc.",
  "TRG",
  "Walt Disney",
  "Viasat",
]));
pastCompanies.sort((a, b) => a.toLowerCase() <= b.toLowerCase() ? -1 : 1);
